import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { Image, Typography } from "antd";
import {
  UserAddOutlined,
  FolderOpenTwoTone,
  FundTwoTone,
} from "@ant-design/icons";
import { breakpoints } from "theme/media";
import { Menu, Sider } from "./elements";
import Logo from "./veikulWhite.png";

const { Item, SubMenu } = Menu;
const { Text } = Typography;
const Sidebar = ({ history, collapsed, onCollapse }) => {
  const [isLg, toggleLg] = useState(window.innerWidth > breakpoints.lg);

  useEffect(() => {
    const updateWidth = () => toggleLg(window.innerWidth > breakpoints.lg);
    window.addEventListener("resize", updateWidth);

    return () => window.removeEventListener("resize", updateWidth);
  }, []);
  let routes = (
    <>
      <Item icon={<FundTwoTone twoToneColor={"twoToneColor"} />} key="/map">
        <Link to="/map">
          <Text strong style={{ color: "white" }}>
            Mapa
          </Text>
        </Link>
      </Item>
      <Item
        icon={<FundTwoTone twoToneColor={"twoToneColor"} />}
        key="/monitoring"
      >
        <Link to="/monitoring">
          <Text strong style={{ color: "white" }}>
            Monitoreo
          </Text>
        </Link>
      </Item>

      <Item icon={<FundTwoTone twoToneColor={"twoToneColor"} />} key="/clients">
        <Link to="/clients">
          <Text strong style={{ color: "white" }}>
            Clientes
          </Text>
        </Link>
      </Item>
      <SubMenu
        icon={<FolderOpenTwoTone twoToneColor={"twoToneColor"} />}
        title={
          <Text strong style={{ color: "white" }}>
            Choferes
          </Text>
        }
      >
        <Item icon={<UserAddOutlined />} key="/drivers/active">
          <Link to="/drivers/active">Activos</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/drivers/removed">
          <Link to="/drivers/removed">Bajas</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/drivers/safety">
          <Link to="/drivers/safety">Seguridad</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/drivers/suspension">
          <Link to="/drivers/suspension">Suspensión</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/drivers/references">
          <Link to="/drivers/references">Referencias</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/drivers/payments">
          <Link to="/drivers/payments">Pagos</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/drivers/map">
          <Link to="/drivers/map">Domicilios</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/drivers/documents">
          <Link to="/drivers/documents">Documentos</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/drivers/permissions">
          <Link to="/drivers/permissions">Permisos</Link>
        </Item>
      </SubMenu>
      <SubMenu
        icon={<FolderOpenTwoTone twoToneColor={"twoToneColor"} />}
        title={
          <Text strong style={{ color: "white" }}>
            Unidades
          </Text>
        }
      >
        <Item icon={<UserAddOutlined />} key="/vehicles/active">
          <Link to="/vehicles/active">Activos</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/vehicles/status">
          <Link to="/vehicles/status">Estatus</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/vehicles/driver-pair">
          <Link to="/vehicles/driver-pair">Duplas</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/vehicles/damages">
          <Link to="/vehicles/damages">Siniestros</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/vehicles/immobilize">
          <Link to="/vehicles/immobilize">Sesiones</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/vehicles/tickets">
          <Link to="/vehicles/tickets">Multas</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/vehicles/inspections">
          <Link to="/vehicles/inspections">Inspecciónes</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/vehicles/maintenance">
          <Link to="/vehicles/maintenance">Mantenimiento</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/vehicles/misuse">
          <Link to="/vehicles/misuse">Mal Uso</Link>
        </Item>
      </SubMenu>
      <SubMenu
        icon={<FolderOpenTwoTone twoToneColor={"twoToneColor"} />}
        title={
          <Text strong style={{ color: "white" }}>
            Servicios
          </Text>
        }
      >
        <Item icon={<UserAddOutlined />} key="/services/history">
          <Link to="/services/history">Historial</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/services/validation">
          <Link to="/services/validation">Validacion</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/services/rides">
          <Link to="/services/rides">Rides</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/services/weekly">
          <Link to="/services/weekly">Semanal</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/services/drivers">
          <Link to="/services/drivers">Choferes</Link>
        </Item>
      </SubMenu>
      <SubMenu
        icon={<FolderOpenTwoTone twoToneColor={"twoToneColor"} />}
        title={
          <Text strong style={{ color: "white" }}>
            Catalogos
          </Text>
        }
      >
        <Item icon={<UserAddOutlined />} key="/catalogs/users">
          <Link to="/catalogs/users">Usuarios</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/catalogs/zones">
          <Link to="/catalogs/zones">Zonas</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/catalogs/gasoline">
          <Link to="/catalogs/gasoline">Gasolinas</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/catalogs/bindings">
          <Link to="/catalogs/bindings">Permisos</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/catalogs/fourtrackerrors">
          <Link to="/catalogs/fourtrackerrors">Errores 4Track</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/catalogs/alerts">
          <Link to="/catalogs/alerts">Alertas</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/catalogs/origins">
          <Link to="/catalogs/origins">Origenes</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/catalogs/monitor">
          <Link to="/catalogs/monitor">Monitoristas</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/catalogs/cordinator">
          <Link to="/catalogs/cordinator">Coordinadores</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/catalogs/lastmile">
          <Link to="/catalogs/lastmile">Ultima Milla</Link>
        </Item>
      </SubMenu>
      <SubMenu
        icon={<FolderOpenTwoTone twoToneColor={"twoToneColor"} />}
        title={
          <Text strong style={{ color: "white" }}>
            Propietarios
          </Text>
        }
      >
        <Item icon={<UserAddOutlined />} key="/owners/active">
          <Link to="/owners/active">Activos</Link>
        </Item>
      </SubMenu>
      <SubMenu
        icon={<FolderOpenTwoTone twoToneColor={"twoToneColor"} />}
        title={
          <Text strong style={{ color: "white" }}>
            Potenciales
          </Text>
        }
      >
        <Item icon={<UserAddOutlined />} key="/leads/drivers">
          <Link to="/leads/drivers">Conductores</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/leads/visits">
          <Link to="/leads/visits">Citas</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/leads/analytics">
          <Link to="/leads/analytics">Analisis</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/leads/clients">
          <Link to="/leads/clients">Clientes</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/leads/offers">
          <Link to="/leads/offers">Ofertas</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/leads/requests">
          <Link to="/leads/requests">Solicitudes</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/leads/support">
          <Link to="/leads/support">Soporte</Link>
        </Item>
      </SubMenu>
      <Item icon={<FundTwoTone twoToneColor={"twoToneColor"} />} key="/reports">
        <Link to="/reports">
          <Text strong style={{ color: "white" }}>
            Reportes
          </Text>
        </Link>
      </Item>

      <SubMenu
        icon={<FolderOpenTwoTone twoToneColor={"twoToneColor"} />}
        title={
          <Text strong style={{ color: "white" }}>
            COD
          </Text>
        }
      >
        <Item icon={<UserAddOutlined />} key="/cod/destinations">
          <Link to="/cod/destinations">Destinos</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/cod/routes">
          <Link to="/cod/routes">Rutas</Link>
        </Item>
        <Item icon={<UserAddOutlined />} key="/cod/cutoff">
          <Link to="/cod/cutoff">Cortes</Link>
        </Item>
      </SubMenu>
      <SubMenu
        icon={<FolderOpenTwoTone twoToneColor={"twoToneColor"} />}
        title={
          <Text strong style={{ color: "white" }}>
            Nacionales
          </Text>
        }
      >
        <Item
          icon={<FundTwoTone twoToneColor={"twoToneColor"} />}
          key="/parcels"
        >
          <Link to="/parcels">
            <Text strong style={{ color: "white" }}>
              Envíos
            </Text>
          </Link>
        </Item>
        <Item
          icon={<FundTwoTone twoToneColor={"twoToneColor"} />}
          key="/overweight"
        >
          <Link to="/overweight">
            <Text strong style={{ color: "white" }}>
              Sobrepeso
            </Text>
          </Link>
        </Item>
      </SubMenu>
    </>
  );
  return (
    <Sider
      theme="dark"
      collapsedWidth={isLg ? "100" : "0"}
      collapsed={collapsed}
      collapsible
      style={{
        overflow: "scroll",
        marginBottom: 45,
        background: "radial-gradient(ellipse at top, #000000, #142b22)",
      }}
      onCollapse={onCollapse}
    >
      <Image
        style={{
          margin: "15px auto",
          display: "block",
          paddingLeft: 40,
          paddingRight: 40,
        }}
        height={25}
        src={Logo}
        alt=""
      />
      <Menu
        theme="dark"
        style={{
          marginTop: 20,
          background: "transparent",
          paddingg: 10,
        }}
        defaultSelectedKeys={history.location.pathname.toLowerCase()}
        selectedKeys={history.location.pathname.toLowerCase()}
        mode="inline"
      >
        {routes}
      </Menu>
    </Sider>
  );
};

export default withRouter(Sidebar);
